export default __webpack_public_path__ + "static/media/thumbnail-opportunity-rectangle.10e59cbe.png";